export default __webpack_public_path__ + "static/media/friend-confirmed.d0a34ed9.svg";